export const userRoles = {
  CORPORATE_CREATE: 'Corporate Create',
  CORPORATE_VIEW: 'Corporate View',
  DIVISION_CREATE: 'Division Create',
  DIVISION_VIEW: 'Division View',
}

export const UNAUTHORIZED_MESSAGE =
  "The request can't be completed due to invalid privileges associated with your user account."
